import { createContext, useState, useContext } from "react";

export const HOME_URL = '/';
export const ARTICLE_LIST_URL = '/article';
export const CREATE_ARTICLE_URL = "/article/create";
export const USER_LIST_URL = "/users";
export const CREATE_USER_URL = "/user/create";
export const UPDATE_ARTICLE_URL = '/article/update';
export const UPDATE_USER_URL = '/user/update';
export const ARTICLE_CATEGORY_URL = 'article/category';

export const PageContext = createContext();

export const PageProvider = ({children}) => {
    const [pageData, setPageData] = useState({});    

    return (
        <PageContext.Provider value={{pageData, setPageData}}>
            {children}
        </PageContext.Provider>
    );
};

export const usePage = () => useContext(PageContext);